export const PRESALE_TRACKER_SLUG = 'tickets-presold'
export const BOX_OFFICE_TRACKER_SLUG = 'total-box-office-tickets'
